import type { DynamicEventsResponse, FunnelEvents } from "@/api/insights";

import { getPreviewGraph } from "../graph";

export function handleGetEventDefsEnriched(_params: {}): FunnelEvents[] {
  const graph = getPreviewGraph();
  return [...graph.eventDefs].sort((a, b) =>
    a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  );
}

export function handleGetDynamicEvents(_params: {}): DynamicEventsResponse {
  const graph = getPreviewGraph();
  return {
    midFunnel: graph.eventDefs.filter((e) => e.funnelStage === "MidFunnel"),
    bottomFunnel: graph.eventDefs.filter(
      (e) => e.funnelStage === "BottomFunnel",
    ),
  };
}
